import { observer } from 'mobx-react-lite'
import { type FC, useEffect } from 'react'
import { type ITabItem, Tabs } from 'shared/ui'
import type { QuestionnaireOrSelectNumberModalStore } from 'entities/Phone/ui/QuestionnaireOrSelectNumberModal'
import { type ITabsEnum } from 'entities/Phone/types'
import { ChooseNumberTabsContent } from 'entities/Phone/ui/ChooseNumberTabs/ChooseNumberTabsContent'
import styles from './styles.module.scss'

type IStepSelectNumberProps = {
  store: QuestionnaireOrSelectNumberModalStore
}

export const StepSelectNumber: FC<IStepSelectNumberProps> = observer(({ store }) => {
  const { numberModalStore, summary } = store
  const { chooseNumberStore } = numberModalStore

  useEffect(() => {
    chooseNumberStore.preselectCountry()
    chooseNumberStore.initActiveTab()

    return numberModalStore.dispose
  }, [])

  const handleActiveTab = (item: ITabItem) => {
    const tabKey = item.key as ITabsEnum
    chooseNumberStore.setActiveTab(tabKey)
  }

  return (
    <div className={styles.wrap}>
      {summary?.isNumberAll && (
        <div className={styles.tabs}>
          <Tabs
            tabs={chooseNumberStore.tabs}
            activeTabKey={chooseNumberStore.activeTab}
            handleSelectTab={handleActiveTab}
          />
        </div>
      )}

      <ChooseNumberTabsContent store={chooseNumberStore} />
    </div>
  )
})
